import {createApi} from '@reduxjs/toolkit/query/react';
import {axiosBaseQuery} from './api-utils';
import {BglWebAndMobileConfig} from '../../config';
import {LuxtrustType, PhysicalTokenType} from '../@types/AuthentTypes';
import {LuxtrustChallengeResponse} from '../@types/GclTypes';
import {CreateProspectFromPreInstructionChallengeRequest} from '../@types/PublicIdentAuthentTypes';

const URL_API = '/logon_ident';

export const publicIdentAuthentApi = createApi({
    reducerPath: 'publicIdentAuthentApi',
    baseQuery: axiosBaseQuery({
        baseUrl: URL_API
    }),
    keepUnusedDataFor: 1,
    invalidationBehavior: 'immediately',
    refetchOnFocus: true,

    endpoints: (builder) => ({
        getValidationChallenge: builder.query<LuxtrustChallengeResponse, {
            luxtrustType?: LuxtrustType,
            tokenTypeList?: PhysicalTokenType[]
        }>({
            query: ({luxtrustType, tokenTypeList}) => ({
                url: '/rest/v1/signin/validationChallenge/get',
                method: 'POST',
                data: {
                    applicationName: BglWebAndMobileConfig.get('applicationCaller'),
                    luxTrustType: luxtrustType?.toUpperCase(),
                    tokenType: tokenTypeList ? tokenTypeList[0] : null,
                    connectionType: 'SMID'
                }
            })
        }),
        createProspectValidationForRemoteSales: builder.mutation<void, CreateProspectFromPreInstructionChallengeRequest>({
            query: (data) => ({
                url: '/rest/v1/signin/createProspectValidationForRemoteSales',
                method: 'POST',
                data
            })
        })
    })
});

export const {
    useGetValidationChallengeQuery,
    useCreateProspectValidationForRemoteSalesMutation,
} = publicIdentAuthentApi;
